import { useRef, useState, Fragment } from 'react';
import { type IBankAccountConfig } from '@recargas-dominicanas/core/types';
import { TableRow, Cell, CellIcon, Menu } from '@recargas-dominicanas/core/components';
import { MenuOption } from '../../../../components/menu-option/menu-option.component';
import { BankAccountStore } from '../../../../store/bankAccountStore';
import { EditModal } from '../editModal/edit-modal.component';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { ConfirmModal } from '../../../../components/confirm-modal/confirm-modal.component';
import { style } from './config-row.module.css';

interface Props {
  bankAccountId: number;
  config: IBankAccountConfig;
}

export function ConfigRow(props: Props) {

  const {
    bankAccountId,
    config
  } = props;

  const menuIconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  function handleOpenEditModal() {
    setOpenEditModal(true);
    setOpenMenu(false);
  }

  function handleOpenDeleteModal() {
    setOpenDeleteModal(true);
    setOpenMenu(false);
  }

  async function handleEdit(key: string, value: string) {
    await BankAccountApi.updateConfig(bankAccountId, config.id, key, value);
    BankAccountStore.fetchConfigs(bankAccountId);
  }

  async function handleDelete() {
    await BankAccountApi.deleteConfig(config.id);
    BankAccountStore.fetchConfigs(bankAccountId);
  }

  return (
    <Fragment>
      <TableRow key={config.id}>
        <Cell color='darkgray' weight='medium' text={config.key}/>
        <Cell text={config.value}/>
        <CellIcon
          refIcon={menuIconRef} 
          icon='more_horiz' 
          onClick={() => setOpenMenu(open => !open)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={menuIconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption text='Editar' onClick={handleOpenEditModal}/>
        <MenuOption text='Borrar' onClick={handleOpenDeleteModal}/>
      </Menu>
      <EditModal
        title='Editar configuración'
        config={config}
        errorMessage='Error editando configuración'
        open={openEditModal}
        onSave={handleEdit}
        onClose={() => setOpenEditModal(false)}/>
      <ConfirmModal
        open={openDeleteModal}
        title='Borrar configuracion'
        description='Esta seguro de borrar esta configuracion'
        onConfirm={handleDelete}
        onClose={() => setOpenDeleteModal(false)}>
        <div className={style.configItem}>
          <div className={style.configItemName}>{config.key}</div>
          <div className={style.configItemValue}>{config.value}</div>
        </div>
      </ConfirmModal>
    </Fragment>
  );
}
